export default __webpack_public_path__ + "static/media/arrow-right.d86f0746.svg";